// extracted by mini-css-extract-plugin
export default {"warningBox":"styles_warningBox__zexut","danger":"styles_danger__U8Ki+","content":"styles_content__WH9Fz"};